import { Box, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const EditingHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '32px',
}) as typeof Box;

export const EditingHeaderTitle = styled(Typography)({
  color: palette.text.header,
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '29px',
}) as typeof Typography;
